import axios from "axios";
import { WalletHistoryResponse } from "redmond";
import { config } from "../../config";
import { travelWalletApiPrefix } from "../paths";

const END_POINT: string = `${travelWalletApiPrefix}/history`;

export const fetchTravelWalletCreditHistory = async (): Promise<WalletHistoryResponse> => {
  const res = await axios.get(END_POINT, {
    baseURL: config.baseURL,
  });
  return res.data;
};
